import '../App.css';
import '../style.css';
import '../font.css';
import '../workDetailPage/style_works.css';
import { ArticleMainImage } from './ArticleMainImage';
import { Thumbnail } from '../components/WorkThumbnail';
import { Divider } from '@mui/material';

export function ArticleTitle(props: {
    title: string; 
    description? : React.ReactNode ;
    category? : string;
    date? : string;
    showButton?: boolean;
    buttonLabel?: string;
    buttonHref?: string;
    thumbnail?:string;
}) {
    return (
        <div className='articleTitleSection'> 
         <div className='articleTitleSectionGap'> 
                {props.thumbnail && (
                    <ArticleMainImage image={props.thumbnail} />
                )}
                <div className='gap48'>
                    <div className='articleTitleSectionTitleGap'>
                        <div className='articlePageTitle'>{props.title}</div>
                        {props.description && (
                            <div className='articlePageDescription'>{props.description}</div>
                        )}
                    </div>
                    {(props.category || props.date) && (
                        <div className='articleTitleSectionTag'>
                            {props.category && <div className='articlePageCategory'>{props.category}</div>}
                            {props.category && props.date && '·'}
                            {props.date && <div className='articlePageDate'>{props.date}</div>}
                        </div>
                    )}
                </div>
                </div>
                <Divider className = 'divider2'/>
            <div>   
        </div>
        </div>
    )
}
